import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDemoContentByModule } from "../redux/demoContentSlice";
import Popup from "../features/EventOrganiser/Popup";

// Small "i" button that shows a Demo Video / Demo Document dropdown for a module.
// Drop this next to a module header's profile button, passing the backend module_name.
const DemoContentButton = ({ moduleName }) => {
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [viewer, setViewer] = useState(null); // { type: "video" | "doc", url, title }

  const demoData = useSelector(
    (state) => state.demoContent.dataByModule[moduleName],
  );
  console.log("demoData", demoData);
  const loading = useSelector(
    (state) => state.demoContent.loadingByModule[moduleName],
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!moduleName) return null;

  const hasVideo = demoData?.is_published && demoData?.video_file_url;
  const hasDoc = demoData?.is_published && demoData?.doc_file_url;

  const toggleMenu = () => {
    const willOpen = !menuOpen;
    setMenuOpen(willOpen);
    if (willOpen && !demoData) {
      dispatch(fetchDemoContentByModule(moduleName));
    }
  };

  const openViewer = (type, url, title) => {
    setMenuOpen(false);
    setViewer({ type, url, title });
  };

  return (
    <>
      <div ref={wrapperRef} style={{ position: "relative", display: "inline-block" }}>
        <button
          type="button"
          title="Demo video / document"
          onClick={toggleMenu}
          style={{
            width: "26px",
            height: "26px",
            borderRadius: "50%",
            border: "none",
            background: "rgba(255,255,255,0.9)",
            color: "#333",
            fontSize: "13px",
            fontWeight: 700,
            fontStyle: "italic",
            fontFamily: "Georgia, serif",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          i
        </button>
        {menuOpen && (
          <div
            style={{
              position: "absolute",
              top: "32px",
              right: 0,
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
              minWidth: "170px",
              overflow: "hidden",
              zIndex: 2000,
            }}
          >
            <div
              onClick={() =>
                hasVideo &&
                openViewer(
                  "video",
                  demoData.video_file_url,
                  `${moduleName} - Demo Video`,
                )
              }
              style={{
                padding: "10px 14px",
                fontSize: "13px",
                color: hasVideo ? "#1a1a1a" : "#aaa",
                cursor: hasVideo ? "pointer" : "not-allowed",
                borderBottom: "1px solid #eee",
              }}
            >
              🎬 Demo Video
            </div>
            <div
              onClick={() =>
                hasDoc &&
                openViewer(
                  "doc",
                  demoData.doc_file_url,
                  `${moduleName} - Demo Document`,
                )
              }
              style={{
                padding: "10px 14px",
                fontSize: "13px",
                color: hasDoc ? "#1a1a1a" : "#aaa",
                cursor: hasDoc ? "pointer" : "not-allowed",
              }}
            >
              📄 Demo Document
            </div>
            {loading && (
              <div style={{ padding: "8px 14px", fontSize: "12px", color: "#888" }}>
                Loading...
              </div>
            )}
            {!loading && demoData && !hasVideo && !hasDoc && (
              <div style={{ padding: "8px 14px", fontSize: "12px", color: "#888" }}>
                No demo content available
              </div>
            )}
          </div>
        )}
      </div>
      {viewer && (
        <Popup
          title={viewer.title}
          maxWidth="800px"
          minHeight="450px"
          onClose={() => setViewer(null)}
        >
          {viewer.type === "video" ? (
            <video
              src={viewer.url}
              controls
              autoPlay
              style={{ width: "100%", maxHeight: "500px" }}
            />
          ) : (
            <iframe
              title={viewer.title}
              src={
                /\.pdf$/i.test(viewer.url)
                  ? viewer.url
                  : `https://docs.google.com/gview?url=${encodeURIComponent(viewer.url)}&embedded=true`
              }
              style={{ width: "100%", height: "500px", border: "none" }}
            />
          )}
        </Popup>
      )}
    </>
  );
};

export default DemoContentButton;
